module.exports = __webpack_public_path__ + "media/images/icons/vendors/webpic/soundandlights-c85dcf3b34fbe00bb3597b2136bfbace.webp";